const state = {};

const getters = {};

const mutations = {};

const actions = {
	// const scrollElements = document.querySelectorAll(".js-scroll");//ターゲット指定
	init(state, {el, dividend = 1 }) {
		return new Promise(resolve => {
			// 要素があったらフィールドに追加。
			const handleScrollAnimation = () => {
				if (elementInView(el, dividend)) {
					resolve(el);
					window.removeEventListener('scroll', handleScrollAnimation, false);
				} else if (elementOutOfView(el)) {
					// hideScrollElement(el);
				}
			};
			
			const elementInView = (element, dividend) => {
				const elementTop = element.getBoundingClientRect().top;
				return (
					elementTop <=
					(window.innerHeight || document.documentElement.clientHeight) / dividend
				);
			};
			
			const elementOutOfView = element => {
				const elementTop = element.getBoundingClientRect().top;//ページの上部から要素の距離を取得
				return (
					elementTop > (window.innerHeight || document.documentElement.clientHeight)//ビューポートの高さを取得
				);
			};
			
			handleScrollAnimation();
			window.addEventListener('scroll', handleScrollAnimation, {passive: true, capture: false});
		});
	},
	
};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}